import React from "react";
import Table from "../../../../Components/Table/Table";
import SkeletonRow from "../../../../Components/SkeletonRow";
import { useTranslation } from "../../../../context/Internationalization";
import { createEmptyData } from "../../../../utility/Utils";
import BanReportsTableRow from "./BanReportsTableRow";

const schema = (t) => [
  { id: "reportedUser", label: t("reported_user") },
  { id: "reportedTeam", label: t("reported_team") },
  { id: "reporterUser", label: t("reporter_user") },
  { id: "reason", label: t("reason") },
  { id: "comment", label: t("comment") },
  { id: "status", label: t("status") },
  { id: "createdAt", label: t("created_at") },
  { id: "actions", label: "" },
];

const BanReportsTable = ({
  reports,
  lastElementRef,
  loading,
  onOpenReview,
}) => {
  const { t } = useTranslation();

  const rows = loading ? [...reports, ...createEmptyData()] : reports;

  const rowElement = (report, index) => {
    if (report.skeleton) {
      return (
        <SkeletonRow
          key={index}
          rowKey={index}
          columnsCount={schema(t).length}
        />
      );
    }
    return (
      <BanReportsTableRow
        key={report._id}
        report={report}
        index={index}
        lastElementRef={lastElementRef}
        onOpenReview={onOpenReview}
      />
    );
  };

  return <Table rows={rows} columns={schema(t)} rowElement={rowElement} />;
};

export default BanReportsTable;
